export default class AppViewModel {
  apiVersion = 'v1.0.0';
  mainNavRoutes = [{name: 'Home', title: 'Inicio', icon: 'home'}];
  theUserMenuDropList = [];
}
